import React, { Fragment } from 'react';
import { PageTitle } from './shared/PageTitle';
import { SearchBar } from './layout/SearchBar';

export const SearchResults = props => {
  const query = props.match.params.query;

  return (
    <Fragment>
      <div className="page-container">
        <div className="page-panel">
          <PageTitle parts={[query, 'Search']} title="Search Results" />

          <section className="">
            <SearchBar
              isFullView={true}
              inline={true}
              value={query}
              onChange={(value, method) => {
                if (['type', 'escape'].includes(method)) {
                  props.history.replace(`/search/${encodeURIComponent(value)}`);
                }
              }}
            />
          </section>
        </div>
      </div>
    </Fragment>
  );
};
